(function () {
  let swipers = [];

  function initAnytimeSwipers() {
    const sliders = document.querySelectorAll('.drinks-grid__slider');

    sliders.forEach((sliderEl, index) => {
      const nextBtn = sliderEl.querySelector('.swiper-button-next');
      const prevBtn = sliderEl.querySelector('.swiper-button-prev');

      // Create swiper if mobile and not already created
      if (window.innerWidth < 1000) {
        if (!swipers[index]) {
          swipers[index] = new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
          });
        }
      }

      // Destroy swiper on desktop
      if (window.innerWidth >= 1000 && swipers[index]) {
        swipers[index].destroy(false, true);
        swipers[index] = null;
      }
    });
  }

  // Initial load
  initAnytimeSwipers();

  // Debounced resize listener
  window.addEventListener('resize', () => {
    clearTimeout(window._anytimeResizeTimer);
    window._anytimeResizeTimer = setTimeout(initAnytimeSwipers, 150);
  });
})();
